import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {Form, FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {MatSelectChange} from '@angular/material/select';
import {REGIONS} from '../../../../../constants/constants';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {Countries} from '../../../../../admin/models/countries.interface';
import {DownloadDataService} from '../../../../../core/services/download-data.service';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-european-trend-filters',
  templateUrl: './european-trend-filters.component.html',
  styleUrls: ['./european-trend-filters.component.scss']
})
export class EuropeanTrendFiltersComponent implements OnInit, OnChanges {

  regions = REGIONS;

  @ViewChild('allSelected') private allSelected!: MatOption;
  @ViewChild('allCountriesSelected') private allCountriesSelected!: MatOption;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];
  @Input()
  countryCategory!: string;

  searchForm = this.formBuilder.group({
    year: [''],
    countries: [''],
    categoryType: ['NEW'],
    categories: [''],
    member: [],
    region: [''],
    detailLevel: [],
    b2bB2c: [],
    order: [],
    displayUnits: ['ABSOLUTE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get countriesControl(): FormControl {
    return this.searchForm.get('countries') as FormControl;
  }

  get categoryTypeControl(): FormControl {
    return this.searchForm.get('categoryType') as FormControl;
  }

  get categoriesControl(): FormControl {
    return this.searchForm.get('categories') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }

  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }

  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  get displayUnits(): FormControl {
    return this.searchForm.get('displayUnits') as FormControl;
  }

  @Input()
  countries!: Countries[];
  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();
  @Output()
  loadCategories: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder,
              private readonly downloadDataService: DownloadDataService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[2]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categories?.length) {
      if (changes.categories || !this.categoriesControl.value || this.categoriesControl.value.length === this.categories.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.categoriesControl
          .patchValue([...this.categories.map(item => item.id.toString()), 0]);
      }
    }

    if (this.countries?.length) {
      if (!this.countriesControl.value || this.countriesControl.value.length === this.countries.length) {
        if (this.allCountriesSelected) {
          this.allCountriesSelected.select();
        }
        this.countriesControl
          .patchValue([...this.countries.map(item => item.id), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      countries: this.countriesControl.value,
      categoryType: this.categoryTypeControl.value,
      categories: this.categoriesControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      order: this.orderControl.value,
      displayUnits: this.displayUnits.value,
    };
    this.search.emit(search);
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[2]);
    this.countriesControl.reset();
    this.categoryTypeControl.setValue('NEW');
    this.categoriesControl.setValue('');
    this.memberControl.reset();
    this.regionControl.reset();
    this.detailLevelControl.reset();
    this.b2bB2cControl.reset();
    this.orderControl.setValue(null);
    this.searchForm.controls.displayUnits.setValue('ABSOLUTE');
    this.search.emit({categoryType: 'NEW', displayUnits: 'ABSOLUTE', startYear: this.years[2]});
  }

  getCategories(event: MatSelectChange): void {
    if (event?.value) {
      this.loadCategories.emit(event.value);
    }
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }


  toggleCountryPerOne(): void {
    if (this.allCountriesSelected.selected) {
      this.allCountriesSelected.deselect();
      return;
    }
    if (this.countriesControl.value.length === this.countries.length) {
      this.allCountriesSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.categoriesControl
        .patchValue([...this.categories.map(item => item.id.toString()), 0]);
    } else {
      this.categoriesControl.patchValue([]);
    }
  }


  toggleAllCountriesSelection(): void {
    if (this.allCountriesSelected.selected) {
      this.countriesControl
        .patchValue([...this.countries.map(item => item.id), 0]);
    } else {
      this.countriesControl.patchValue([]);
    }
  }

}
